<div class="bg-white border m-2 py-3 px-3 shadow-sm">
  <h5>Unavailable</h5>
  <p>
    <span class="text-danger">Warning:</span> Marking a device as unavailable will take it out of single app mode, so it
    can be diagnosed. Make sure the device is not in a guest room. <br />
    This action should only be performed when the device is malfunctioning.
  </p>
  <button type="submit"
          class="btn btn-danger me-2"
          (click)="markAsUnavailable()">Confirm</button>
  <a class="btn btn-outline-primary"
     [routerLink]="['../']">Cancel</a>
</div>